module.exports = __webpack_public_path__ + "media/firstshuaige.7be68507.mp3";